import { render, staticRenderFns } from "./angleIcon.vue?vue&type=template&id=2a33c476&scoped=true&"
import script from "./angleIcon.vue?vue&type=script&lang=js&"
export * from "./angleIcon.vue?vue&type=script&lang=js&"
import style0 from "./angleIcon.vue?vue&type=style&index=0&id=2a33c476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33c476",
  null
  
)

export default component.exports